var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgTagVariant = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m12.953 4.731 6.316 6.316a.79.79 0 0 1 0 1.116l-7.106 7.105a.79.79 0 0 1-1.116 0l-6.316-6.316a.79.79 0 0 1-.231-.558V5.29a.79.79 0 0 1 .79-.789h7.105a.8.8 0 0 1 .558.231Zm-1.348 12.862 5.99-5.988-5.527-5.526h-5.99v5.989zM8.84 10.026a1.188 1.188 0 1 1 0-2.376 1.188 1.188 0 0 1 0 2.376"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTagVariant);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/tag-variant.719ed223.svg";